import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import HttpApi from 'i18next-http-backend'


//how to use translations - these only work with components because of hooks
//first add to the public/assets/locales/{lng}/translation.json files and give each piece of text a unique identifier
// then at the top of the component: import { useTranslation } from 'react-i18next' 
// then put this inside the component: const { t } = useTranslation();
// when you want to translate: t('unique identifier') 


i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(I18nextBrowserLanguageDetector)
  .use(HttpApi)
  .init({
    fallbackLng: 'en',
    backend: {
        loadPath: '/assets/locales/{{lng}}/translation.json'
    },
    react: {
        useSuspense: false 
    }
  });

  export default i18n;